import type { ApolloError } from '@apollo/client'

import i18n from '@/utils/i18n'

export const FUNDS_PIN_INVALID_ERROR_CODE = 3015
export const FUNDS_PIN_RATE_LIMIT_ERROR_CODE = 2022

function extensionNumber(value: unknown): number | undefined {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : undefined
}

function retryDelayLabel(retryAfterSeconds: number): string {
  const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60))
  if (minutes < 60) {
    return i18n.t('paymentMethod:retryMinutes', { count: minutes })
  }

  const hours = Math.ceil(minutes / 60)
  return i18n.t('paymentMethod:retryHours', { count: hours })
}

export function fundsPinErrorMessage(error: Pick<ApolloError, 'graphQLErrors'>): string | undefined {
  const graphqlError = error.graphQLErrors[0]
  const code = extensionNumber(graphqlError?.extensions?.code)

  if (code === FUNDS_PIN_RATE_LIMIT_ERROR_CODE) {
    const retryAfterSeconds = extensionNumber(graphqlError?.extensions?.retryAfterSeconds)
    return retryAfterSeconds === undefined
      ? i18n.t('paymentMethod:transactionPasswordLocked')
      : i18n.t('paymentMethod:transactionPasswordLockedUntil', { delay: retryDelayLabel(retryAfterSeconds) })
  }

  if (code === FUNDS_PIN_INVALID_ERROR_CODE) {
    const attemptsRemaining = extensionNumber(graphqlError?.extensions?.attemptsRemaining)
    if (attemptsRemaining === undefined) {
      return i18n.t('paymentMethod:transactionPasswordIncorrect')
    }
    if (attemptsRemaining === 1) {
      return i18n.t('paymentMethod:transactionPasswordLastAttempt')
    }
    return i18n.t('paymentMethod:transactionPasswordAttemptsRemaining', { count: attemptsRemaining })
  }

  return undefined
}
